import http from '@/util/http'

// 添加产品参数与值
export function addProductClassParam (data) {
  return http({
    url: '/api/productClassParam/addProductClassParam',
    method: 'post',
    data: data
  })
}
// 修改产品基本信息
export function productBaseUpdateProduct (data) {
  return http({
    url: '/api/productBase/updateProduct',
    method: 'post',
    data: data
  })
}
// 库存备货列表查询
export function queryOrderContractStockupStorage (page, processState, size, data) {
  return http({
    url: `/api/storageBase/queryOrderContractStockupStorage/${page}/${processState}/${size}`,
    method: 'post',
    data: data
  })
}
// 库存备货清单（认领）
export function updateStorageProcessState (operate, data) {
  return http({
    url: `/api/storageBase/updateStorageProcessState/${operate}`,
    method: 'post',
    data: data
  })
}
// 库存备货清单（提取）
export function updateStorageProcessStateExtract (operate, data) {
  return http({
    url: `/api/storageBase/updateStorageProcessStateExtract/${operate}`,
    method: 'post',
    data: data
  })
}
// 库存备货详情
export function queryStockupContent (ocssIds, ocsId, distributionType, data) {
  return http({
    url: `/api/storageBase/queryStockupContent/${ocssIds}/${ocsId}/${distributionType}`,
    method: 'post',
    data: data
  })
}
// 同产品同仓库不同货架库存（报缺仓库可用库存）
export function queryShelvesProduct (sbId, ssId, proId, data) {
  return http({
    url: `/api/storageInventoryExceptionLock/queryShelvesProduct/${sbId}/${ssId}/${proId}`,
    method: 'post',
    data: data
  })
}
// 提交报缺方案
export function addInvnetoryLack (data) {
  return http({
    url: '/api/storageBase/addInvnetoryLack',
    method: 'post',
    data: data
  })
}
// 确认备货
export function addStockup (data) {
  return http({
    url: '/api/storageBase/addStockup',
    method: 'post',
    data: data
  })
}
// 货架迁移->备货详情
export function queryStockupContentMigration (ocssIds, ocsId, distributionType, data) {
  return http({
    url: `/api/storageBase/queryStockupContentMigration/${ocssIds}/${ocsId}/${distributionType}`,
    method: 'post',
    data: data
  })
}
// 批量迁移货架
export function updateAllocation (data) {
  return http({
    url: '/api/storageBase/updateAllocation',
    method: 'post',
    data: data
  })
}
// 调拨备货
export function addStockAllot (data) {
  return http({
    url: '/api/storageBase/addStockAllot',
    method: 'post',
    data: data
  })
}
// 备货详情页-调拨备货
export function queryStockupContentAllot (ocssIds, ocsId, distributionType) {
  return http({
    url: `/api/storageBase/queryStockupContentAllot/${ocssIds}/${ocsId}/${distributionType}`,
    method: 'post'
  })
}
// 备货详情-调拨备货-修改快递物流清单
export function updateStorageDeliverLogisticBond (data) {
  return http({
    url: '/api/storageBase/updateStorageDeliverLogisticBond',
    method: 'post',
    data: data
  })
}
// 备货详情-调拨备货-撤销快递单
export function deleteStorageDeliverBond (sodlbId, mark, data) {
  return http({
    url: `/api/storageBase/deleteStorageDeliverBond/${sodlbId}/${mark}`,
    method: 'post',
    data: data
  })
}
// ----------------------物流入库列表-----------------
// 1-列表查询
export function queryPageInstockup (deliverState, logisticType, page, size, data) {
  return http({
    url: `/api/storageInstock/queryPageInstockup/${deliverState}/${logisticType}/${page}/${size}`,
    method: 'post',
    data: data
  })
}
// 2-入库详情页
export function queryStorageDeliverContentVo (bizId, instockType, data) {
  return http({
    url: `/api/storageInstock/queryStorageDeliverContentVo/${bizId}/${instockType}`,
    method: 'post',
    data: data
  })
}

// 8.物流入库 已处理入库清单
export function queryStorageInstockContent (bizId, instockType, data) {
  return http({
    url: `/api/storageInstock/queryStorageInstockContent/${bizId}/${instockType}`,
    method: 'post',
    data: data
  })
}
// 3-作废入库单
export function updateCancellation (instockType, bizId, data) {
  return http({
    url: `/api/storageInstock/updateCancellation/${instockType}/${bizId}`,
    method: 'post',
    data: data
  })
}
// 4-确认验收
export function updateAccept (data) {
  return http({
    url: '/api/storageInstock/updateAccept',
    method: 'post',
    data: data
  })
}
// 5-确认入库
export function addInstock (data) {
  return http({
    url: '/api/storageInstock/addInstock',
    method: 'post',
    data: data
  })
}

// 6.检索货架-获取货架所有首字母
export function queryFirstShelves (sbId, data) {
  return http({
    url: `/api/storageInstock/queryFirstShelves/${sbId}`,
    method: 'post',
    data: data
  })
}
// 7.检索货架
export function queryStorageShelves (sbId, data) {
  return http({
    url: `/api/storageInstock/queryStorageShelves/${sbId}`,
    method: 'post',
    data: data
  })
}
// 8- 物流入库-待入库-查看侧边栏
export function queryInstockSerialCode (bicId, data) {
  return http({
    url: `/api/storageInstock/queryInstockSerialCode/${bicId}`,
    method: 'post',
    data: data
  })
}
// 9-调拨入库-报缺
export function addAllotLack (data) {
  return http({
    url: '/api/storageInstock/addAllotLack',
    method: 'post',
    data: data
  })
}
// ---------------------------物流/快递发货列表
// 1-首页表单
export function queryPageOutStockp (processState, deliverMode, page, size, data) {
  return http({
    url: `/api/storageOutstock/queryPageOutStockp/${processState}/${deliverMode}/${page}/${size}`,
    method: 'post',
    data: data
  })
}
// 2-发货详情
export function queryStorageOutStockDetailsVo (soId, data) {
  return http({
    url: `/api/storageOutstock/queryStorageOutStockDetailsVo/${soId}`,
    method: 'post',
    data: data
  })
}
// 3-完成发货
export function addLogisticStorageOut (data) {
  return http({
    url: '/api/storageOutstock/addLogisticStorageOut',
    method: 'post',
    data: data
  })
}
// 物流发货详情页-删除物流单号
export function deleteLogisticCustom (loId, data) {
  return http({
    url: `/api/storageOutstock/deleteLogisticCustom/${loId}`,
    method: 'post',
    data: data
  })
}
//  4-物流发货-仓库发货-认领
export function updateState (processState, data) {
  return http({
    url: `/api/storageOutstock/updateState/${processState}`,
    method: 'post',
    data: data
  })
}
//  4-物流/快递发货提取
export function updateStateExtract (soId, processState, data) {
  return http({
    url: `/api/storageOutstock/updateStateExtract/${soId}/${processState}`,
    method: 'post',
    data: data
  })
}
//  4-仓库发货提取
export function updateStateExtractByStorage (soId, processState, data) {
  return http({
    url: `/api/storageOutstock/updateStateExtractByStorage/${soId}/${processState}`,
    method: 'post',
    data: data
  })
}
// 5-作废发货单
export function updateCancellations (soId, data) {
  return http({
    url: `/api/storageOutstock/updateCancellations/${soId}`,
    method: 'post',
    data: data
  })
}
// 6-变更物流信息
export function updateLogisticCustom (data) {
  return http({
    url: '/api/storageOutstock/updateLogisticCustom',
    method: 'post',
    data: data
  })
}
// 7-提交报缺方案
export function addDeliverLack (data) {
  return http({
    url: '/api/storageOutstock/addDeliverLack',
    method: 'post',
    data: data
  })
}
// 8-查看序列号侧边栏
export function querySerialCodes (socId, data) {
  return http({
    url: `/api/storageOutstock/querySerialCodes/${socId}`,
    method: 'post',
    data: data
  })
}

// ---------自提发货
// 1-自提/仓库-发货详情页
export function queryStorageOutstockContentVo (soId, data) {
  return http({
    url: `/api/storageOutstock/queryStorageOutstockContentVo/${soId}`,
    method: 'post',
    data: data
  })
}
// 2-仓库-完成发货
export function addStorageOutstock (data) {
  return http({
    url: '/api/storageOutstock/addStorageOutstock',
    method: 'post',
    data: data
  })
}
// 2-自提-完成发货
export function addStorageOutStockSelfPick (data) {
  return http({
    url: '/api/storageOutstock/addStorageOutStockSelfPick',
    method: 'post',
    data: data
  })
}
// 仓库设置->详细资料
export function queryStorage (page, size, data) {
  return http({
    url: `/api/storageBase/queryStorage/${page}/${size}`,
    method: 'post',
    data: data
  })
}
// 仓库设置-判断是否存在锁库
export function queryStorageProductLock (sbId, data) {
  return http({
    url: `/api/storageBase/queryStorageProductLock/${sbId}`,
    method: 'post',
    data: data
  })
}
// 仓库设置-启用/停用仓库
export function updateStopStorage (sbId, operator, data) {
  return http({
    url: `/api/storageBase/updateStopStorage/${sbId}/${operator}`,
    method: 'post',
    data: data
  })
}
// 仓库设置-新增仓库信息
export function addStorageBasesVo (data) {
  return http({
    url: '/api/storageBase/addStorageBasesVo',
    method: 'post',
    data: data
  })
}
// 仓库设置-修改仓库信息
export function updateStorage (data) {
  return http({
    url: '/api/storageBase/updateStorage',
    method: 'post',
    data: data
  })
}
// 货架管理 - 获取仓库信息
export function houseInformation (data) {
  return http({
    url: '/api/storageShelves/queryStorage',
    method: 'post',
    data: data
  })
}
// 货架管理-查询货架信息(分页)
export function queryShelves (page, size, sbId, data) {
  return http({
    url: `/api/storageShelves/queryShelves/${page}/${size}/${sbId}`,
    method: 'post',
    data: data
  })
}
// 货架管理-根据仓库ID获取所有货架信息(不分页)
export function queryByStorageId (id, data) {
  return http({
    url: `/api/storageShelves/queryByStorageId/${id}`,
    method: 'get',
    data: data
  })
}
// 货架管理-获取货架信息【部分】
export function queryBySbIdSsId (id, data) {
  return http({
    url: `/api/storageShelves/queryBySbIdSsId/${id}`,
    method: 'post',
    data: data
  })
}
// 历史出入库查询 所有货架根据仓库id
export function queryBySbIds (sbIds, data) {
  return http({
    url: `/api/storageShelves/queryBySbIds/${sbIds}`,
    method: 'post',
    data: data
  })
}
// 货架管理-新增货架
export function addShelves (data) {
  return http({
    url: '/api/storageShelves/addShelves',
    method: 'post',
    data: data
  })
}
// 货架管理-更新货架信息（修改货架）
export function updateByIdToName (data) {
  return http({
    url: '/api/storageShelves/updateByIdToName',
    method: 'post',
    data: data
  })
}
// 货架管理-删除货架
export function deleteShelves (ssId, data) {
  return http({
    url: `/api/storageShelves/deleteShelves/${ssId}`,
    method: 'post',
    data: data
  })
}

// 期初库存-查看设置的期初库存
export function checkInventory (sbId, data) {
  return http({
    url: `/api/storageShelvesProduct/queryShelvesProduct/${sbId}`,
    method: 'post',
    data: data
  })
}
// 期初库存-根据分类获取品牌列表
export function queryAllBrandAndSeries (page, size, data) {
  return http({
    url: `/api/productClass/queryAllBrandAndSeries/${page}/${size}`,
    method: 'post',
    data: data
  })
}
// 期初库存-保存
export function addShelvesProduct (data) {
  return http({
    url: '/api/storageShelvesProduct/addShelvesProduct',
    method: 'post',
    data: data
  })
}
// 仓内调拨-查询调拨记录
export function queryAllocation (page, size, data) {
  return http({
    url: `/api/storageAllocationStock/queryAllocation/${page}/${size}`,
    method: 'post',
    data: data
  })
}

// 仓内调拨-查看详情
export function queryShelvesProducts (allocationNumber, data) {
  return http({
    url: `/api/storageAllocationStock/queryShelvesProducts/${allocationNumber}`,
    method: 'post',
    data: data
  })
}
// 仓内调拨-获取货架产品信息
export function getStockProduct (sbId, ssId, data) {
  return http({
    url: `/api/storageAllocationStock/queryShelvesProduct/${sbId}/${ssId}`,
    method: 'post',
    data: data
  })
}
// 仓内调拨-新增
export function addAllocation (data) {
  return http({
    url: '/api/storageAllocationStock/addAllocation',
    method: 'post',
    data: data
  })
}
// 仓内调拨 -调出货架
export function querySsIdBySbIdAndSsId (sbId, ssId, data) {
  return http({
    url: `/api/storageShelves/querySsIdBySbIdAndSsId/${sbId}/${ssId}`,
    method: 'post',
    data: data
  })
}
// 库存盘点-盘点记录
export function queryPageInventory (page, size, sbId, data) {
  return http({
    url: `/api/storageInventoryBase/queryPageInventory/${page}/${size}/${sbId}`,
    method: 'post',
    data: data
  })
}

// 库存盘点-新增盘点记录
export function addInventoryBase (sbId, inventoryName, data) {
  return http({
    url: `/api/storageInventoryBase/addInventoryBase/${sbId}/${inventoryName}`,
    method: 'post',
    data: data
  })
}

// 盘点进行中-查询盘点信息
export function queryPageInventoryShelves (page, size, sibId, data) {
  return http({
    url: `/api/storageInventoryShelves/queryPageInventoryShelves/${page}/${size}/${sibId}`,
    method: 'post',
    data: data
  })
}

// 盘点进行中-盘点详情(盘点)
export function queryAllInventoryContent (page, size, sisId, data) {
  return http({
    url: `/api/storageInventoryShelves/queryAllInventoryContent/${page}/${size}/${sisId}`,
    method: 'post',
    data: data
  })
}

// 盘点进行中-盘点详情
export function queryAllInventory (sisId, data) {
  return http({
    url: `/api/storageInventoryShelves/queryAllInventory/${sisId}`,
    method: 'post',
    data: data
  })
}
// 根据品牌id获取所属系列
export function querySeriesByBrandId (id) {
  return http({
    url: `/api/brandSeries/querySeriesByBrandId/${id}`,
    method: 'get'
  })
}

// 盘点进行中-盘点货架
export function updateInventorys (data) {
  return http({
    url: '/api/storageInventoryShelves/updateInventory',
    method: 'post',
    data: data
  })
}

// 产品盈亏记录
export function queryPageProfitLoss (page, size, data) {
  return http({
    url: `/api/storageInventoryShelves/queryPageProfitLoss/${page}/${size}`,
    method: 'post',
    data: data
  })
}

// 实时库存查询-仓库查询
export function queryAllShelvesStorageName (page, size, data) {
  return http({
    url: `/api/storageShelvesProduct/queryAllShelvesStorageName/${page}/${size}`,
    method: 'post',
    data: data
  })
}
// 实时库存查询-产品查询
export function queryAllShelvesProduct (page, size, data) {
  return http({
    url: `/api/storageShelvesProduct/queryAllShelvesProduct/${page}/${size}`,
    method: 'post',
    data: data
  })
}

// 实时库存查询-查看入库批次
export function queryShelvesProductBatchNumber (sbId, proId, ssId, data) {
  return http({
    url: `/api/storageShelvesProduct/queryShelvesProductBatchNumber/${sbId}/${proId}/${ssId}`,
    method: 'post',
    data: data
  })
}

// 实时库存查询-产品查看入库批次
export function queryProductByBatchNumber (proId, data) {
  return http({
    url: `/api/storageShelvesProduct/queryProductByBatchNumber/${proId}`,
    method: 'post',
    data: data
  })
}

// 实时库存查询-盘点信息
export function updateShelvesProductInventoryShelves (data) {
  return http({
    url: '/api/storageInventoryShelves/updateShelvesProductInventoryShelves',
    method: 'post',
    data: data
  })
}

// 实时库存查询-锁库库存详情
export function queryShelvesProductLock (sbId, ssId, proId, data) {
  return http({
    url: `/api/storageShelvesProduct/queryShelvesProductLock/${sbId}/${ssId}/${proId}`,
    method: 'post',
    data: data
  })
}

// 实时库存查询-产品锁库库存详情
export function queryProductLocks (proId, data) {
  return http({
    url: `/api/storageShelvesProduct/queryProductLocks/${proId}`,
    method: 'post',
    data: data
  })
}

// 审核盘点-盘点任务
export function queryPageAllInventory (auditState, page, size, data) {
  return http({
    url: `/api/storageInventoryShelves/queryPageAllInventory/${auditState}/${page}/${size}`,
    method: 'post',
    data: data
  })
}

// 审核盘点任务-（认领）
export function updateAuditState (operate, data) {
  return http({
    url: `/api/storageInventoryShelves/updateAuditState/${operate}`,
    method: 'post',
    data: data
  })
}
// 审核盘点任务-提取
export function updateAuditStateExtract (sisId, operate, data) {
  return http({
    url: `/api/storageInventoryShelves/updateAuditStateExtract/${sisId}/${operate}`,
    method: 'post',
    data: data
  })
}

// 我的待审核-盘点任务详情
export function queryStorageInventoryContent (sisId, data) {
  return http({
    url: `/api/storageInventoryShelves/queryStorageInventoryContent/${sisId}`,
    method: 'post',
    data: data
  })
}
// 我的待审核-提交审核结果
export function updateInventoryAudit (sisId, auditState, data) {
  return http({
    url: `/api/storageInventoryShelves/updateInventoryAudit/${sisId}/${auditState}`,
    method: 'post',
    data: data
  })
}

// 待处理锁库异常列表
export function queryLockUnusual (page, size, data) {
  return http({
    url: `/api/storageInventoryExceptionLock/queryLockUnusual/${page}/${size}`,
    method: 'post',
    data: data
  })
}

// 已处理锁库异常列表
export function queryProcessed (page, size, data) {
  return http({
    url: `/api/storageInventoryExceptionLock/queryProcessed/${page}/${size}`,
    method: 'post',
    data: data
  })
}

// 待处理锁库异常列表-提交方案
export function addInvnetoryLockWaite (data) {
  return http({
    url: '/api/storageInventoryExceptionLock/addInvnetoryLock',
    method: 'post',
    data: data
  })
}

// 锁库异常已处理-查看详情
export function queryInventoryProcess (seelId, data) {
  return http({
    url: `/api/storageInventoryExceptionLock/queryInventoryProcess/${seelId}`,
    method: 'post',
    data: data
  })
}

// 历史出入库查询（单据查询）
export function queryInOutStockByNumber (page, size, data) {
  return http({
    url: `/api/storageInventoryBase/queryInOutStockByNumber/${page}/${size}`,
    method: 'post',
    data: data
  })
}
// 历史出入库查询（产品查询）
export function queryInOutStockByProduct (page, size, data) {
  return http({
    url: `/api/storageInventoryBase/queryInOutStockByProduct/${page}/${size}`,
    method: 'post',
    data: data
  })
}
// 单据历史出入库查询-详情
export function queryInOutDetails (number, data) {
  return http({
    url: `/api/storageInventoryBase/queryInOutDetails/${number}`,
    method: 'post',
    data: data
  })
}
// 产品历史出入库查询-详情
export function queryInOutProductDetails (sbId, ssId, proId, data) {
  return http({
    url: `/api/storageInventoryBase/queryInOutProductDetails/${sbId}/${ssId}/${proId}`,
    method: 'post',
    data: data
  })
}
// 单据历史出入库查询-产品系列号
export function querySerialCode (contentId, number, data) {
  return http({
    url: `/api/storageInventoryBase/querySerialCode/${contentId}/${number}`,
    method: 'post',
    data: data
  })
}
// 产品历史出入库查询-产品序列号
export function queryProductSerialCode (stockId, proId, ssId, number, data) {
  return http({
    url: `/api/storageInventoryBase/queryProductSerialCode/${stockId}/${proId}/${ssId}/${number}`,
    method: 'post',
    data: data
  })
}
// 历史出入库 -产品查询-根据多个品牌ID获得所属系列
export function querySeriesByMultiBrandId (page, size, ids) {
  return http({
    url: `/api/brandSeries/querySeriesByMultiBrandId/${page}/${size}`,
    method: 'post',
    params: {
      ids: ids
    }
  })
}
